import { IconButton, Tooltip } from "@mui/material";
import { AttachmentActionProps } from "./AttachmentActionProps";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { IconDefinition } from "@fortawesome/pro-regular-svg-icons";
import { MirageTheme } from "@mirage/theme/MuiMirage.module";
import { memo, useCallback } from "react";

export type DownloadActionPredefined = "excel" | "word" | "csv" | "pdf";
interface DownloadActionProps extends Omit<AttachmentActionProps, "attachmentId"> {
    attachmentId?: number | null;
    tooltipTitle?: string;
    icon?: IconDefinition;
    iconSize?: any;
    predefined?: DownloadActionPredefined;
    alwaysShow?: boolean;
}

export const DownloadAction: React.FC<DownloadActionProps> = memo((props) => {
    const {
        attachmentId,
        onDownload,
        tooltipTitle = "Download",
        icon = MirageTheme.icons.arrowDownToLineIcon,
        iconSize = MirageTheme.icons.sizeS,
        predefined,
        alwaysShow = false,
    } = props;
    const predefinedProps = predefined && DownloadActionPredefinedProps[predefined];
    const show = alwaysShow || !!attachmentId;
    const onDownloadClick = useCallback(async () => {
        await onDownload(attachmentId || 0);
    }, [attachmentId, onDownload]);

    if (!show) {
        return null;
    }

    return (
        <Tooltip title={predefinedProps?.tooltipTitle || tooltipTitle}>
            <IconButton onClick={onDownloadClick}>
                <FontAwesomeIcon icon={predefinedProps?.icon || icon} style={iconSize} color={predefinedProps?.iconColor} />
            </IconButton>
        </Tooltip>
    );
});

const DownloadActionPredefinedProps: DownloadActionPredefinedPropsType = {
    csv: {
        icon: MirageTheme.icons.csvIcon,
        iconColor: "#4f4f4f",
        tooltipTitle: "CSV",
    },
    excel: {
        icon: MirageTheme.icons.excelIcon,
        iconColor: "#1D6F42",
        tooltipTitle: "Excel",
    },
    pdf: {
        icon: MirageTheme.icons.pdfIcon,
        iconColor: "#F40F02",
        tooltipTitle: "PDF",
    },
    word: {
        icon: MirageTheme.icons.wordIcon,
        iconColor: "#1B5EBE",
        tooltipTitle: "Word",
    },
};

type DownloadActionPredefinedPropsType = {
    [key in DownloadActionPredefined]: {
        icon: IconDefinition;
        iconColor: string;
        tooltipTitle: string;
    };
};
